export let countryCodes = {
  il: '+972',
  af: '+93',
  al: '+355',
  dz: '+213',
  as: '+1 684',
  ad: '+376',
  ao: '+244',
  ai: '+1 264',
  ag: '+1268',
  ar: '+54',
  am: '+374',
  aw: '+297',
  cc: '+61',
  at: '+43',
  az: '+994',
  bs: '+1 242',
  bh: '+973',
  bd: '+880',
  bb: '+1 246',
  by: '+375',
  be: '+32',
  bz: '+501',
  bj: '+229',
  bm: '+1 441',
  bt: '+975',
  ba: '+387',
  bw: '+267',
  br: '+55',
  io: '+246',
  bg: '+359',
  bf: '+226',
  bi: '+257',
  kh: '+855',
  cm: '+237',
  us: '+1',
  cv: '+238',
  ky: '+ 345',
  cf: '+236',
  td: '+235',
  cl: '+56',
  cn: '+86',
  co: '+57',
  km: '+269',
  cg: '+242',
  ck: '+682',
  cr: '+506',
  hr: '+385',
  cu: '+53',
  cy: '+537',
  cz: '+420',
  dk: '+45',
  dj: '+253',
  dm: '+1 767',
  do: '+1 849',
  ec: '+593',
  eg: '+20',
  sv: '+503',
  gq: '+240',
  er: '+291',
  ee: '+372',
  et: '+251',
  fo: '+298',
  fj: '+679',
  fi: '+358',
  fr: '+33',
  gf: '+594',
  pf: '+689',
  ga: '+241',
  gm: '+220',
  ge: '+995',
  de: '+49',
  gh: '+233',
  gi: '+350',
  gr: '+30',
  gl: '+299',
  gd: '+1 473',
  mf: '+590',
  gu: '+1 671',
  gt: '+502',
  gn: '+224',
  gw: '+245',
  py: '+595',
  ht: '+509',
  hn: '+504',
  hu: '+36',
  is: '+354',
  in: '+91',
  id: '+62',
  iq: '+964',
  ie: '+353',
  it: '+39',
  jm: '+1 876',
  jp: '+81',
  jo: '+962',
  kz: '+7 7',
  ke: '+254',
  ki: '+686',
  kw: '+965',
  kg: '+996',
  lv: '+371',
  lb: '+961',
  ls: '+266',
  lr: '+231',
  li: '+423',
  lt: '+370',
  lu: '+352',
  mg: '+261',
  mw: '+265',
  my: '+60',
  mv: '+960',
  ml: '+223',
  mt: '+356',
  mh: '+692',
  mq: '+596',
  mr: '+222',
  mu: '+230',
  re: '+262',
  mx: '+52',
  mc: '+377',
  mn: '+976',
  me: '+382',
  ms: '+1664',
  ma: '+212',
  mm: '+95',
  na: '+264',
  nr: '+674',
  np: '+977',
  nl: '+31',
  an: '+599',
  nc: '+687',
  nz: '+64',
  ni: '+505',
  ne: '+227',
  ng: '+234',
  nu: '+683',
  nf: '+672',
  mp: '+1 670',
  sj: '+47',
  om: '+968',
  pk: '+92',
  pw: '+680',
  pa: '+507',
  pg: '+675',
  pe: '+51',
  ph: '+63',
  pl: '+48',
  pt: '+351',
  pr: '+1 939',
  qa: '+974',
  ro: '+40',
  rw: '+250',
  ws: '+685',
  sm: '+378',
  sa: '+966',
  sn: '+221',
  rs: '+381',
  sc: '+248',
  sl: '+232',
  sg: '+65',
  sk: '+421',
  si: '+386',
  sb: '+677',
  za: '+27',
  fk: '+500',
  es: '+34',
  lk: '+94',
  sd: '+249',
  sr: '+597',
  sz: '+268',
  se: '+46',
  ch: '+41',
  tj: '+992',
  th: '+66',
  tg: '+228',
  tk: '+690',
  to: '+676',
  tt: '+1 868',
  tn: '+216',
  tr: '+90',
  tm: '+993',
  tc: '+1 649',
  tv: '+688',
  ug: '+256',
  ua: '+380',
  ae: '+971',
  je: '+44',
  uy: '+598',
  uz: '+998',
  vu: '+678',
  wf: '+681',
  ye: '+967',
  zm: '+260',
  zw: '+263',
  ax: '',
  aq: 'null',
  bo: '+591',
  bn: '+673',
  cd: '+243',
  ci: '+225',
  va: '+379',
  hk: '+852',
  ir: '+98',
  kp: '+850',
  kr: '+82',
  la: '+856',
  ly: '+218',
  mo: '+853',
  mk: '+389',
  fm: '+691',
  md: '+373',
  mz: '+258',
  ps: '+970',
  pn: '+872',
  ru: '+7',
  sh: '+290',
  kn: '+1 869',
  lc: '+1 758',
  pm: '+508',
  vc: '+1 784',
  st: '+239',
  so: '+252',
  sy: '+963',
  tw: '+886',
  tz: '+255',
  tl: '+670',
  ve: '+58',
  vn: '+84',
  vg: '+1 284',
  vi: '+1 340',
};



// WEBPACK FOOTER //
// ./routes/book/countryCodes.js